import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./AgriCarbonHow.module.scss";

import Carb from "../../assets/png/Carb.png";
import Animation from "../../assets/mp4/Animation.mp4";
import Compare from "../../assets/mp4/Compare.mp4";

export default class AgriCarbonHow extends Component {
  render() {
    return (
      <section id={styles.AgriCarbonHow}>
        <Container id="HowAgriCarbonWorks" fluid>
          <Row>
            <Col lg={6} id={styles.Box1}>
              <Image src={Carb} id={styles.Carb}></Image>
              <div className={styles.vl}></div>
              <div id={styles.TextBox}>
                <p id={styles.Header}>
                  How <br></br> AgriCarb<span>o</span>
                  <sub>2</sub>n<sup>TM</sup>
                  <br></br> Works
                </p>
                <br></br>
                <p id={styles.SubHeader}>
                  REVOLUTIONIZE YOUR GARDEN<sup>TM</sup>
                </p>
                <br></br>
                <p id={styles.Content}>
                  <b>
                    AgriCarbon naturally and safely converts the carbon dioxide
                  </b>{" "}
                  that is emitted from factories, vehicles, farming, and us,
                  into
                  <b> essential nutrients</b> for{" "}
                  <b>
                    optimal plant growth, greener leaves, and increased crop
                    yields.
                  </b>{" "}
                  By absorbing carbon dioxide, AgriCarbon effectively reduces
                  global greenhouse gases, as well as{" "}
                  <b>recycles coffee waste</b> that would otherwise accumulate
                  in landfills and produce methane and carbon dioxide.
                </p>
              </div>
            </Col>
            <Col lg={6} id={styles.Box2}>
              <video
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                preload="auto"
                id={styles.Animation}
              >
                <source src={Animation} type="video/mp4"></source>
              </video>
              <video
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                preload="auto"
                id={styles.Compare}
              >
                <source src={Compare} type="video/mp4"></source>
              </video>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
